// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1920":"2856587e","3593":"e54f211a","6833":"e54f211a"}[chunkId] + ".chunk.css";
};